//@flow
import FiltersStore from './filtersStoreClass';

export default new FiltersStore();
